import {
    FILE_STATUS_ERROR,
    FILE_STATUS_UPLOADED,
    FILE_STATUS_UPLOADING,
    URL_STATUS_ERROR
} from "../constants/FileStatusConstant";

export const FILE_ADD = 'FILE_ADD';
export const FILE_UPDATE = 'FILE_UPDATE';
export const FILE_PROGRESS = 'FILE_PROGRESS';
export const FILE_SUCCESS = 'FILE_SUCCESS';
export const FILE_DELETE = 'FILE_DELETE';
export const FILE_ERROR = 'FILE_ERROR';

export const fileAdd = (fileEntity) => ({
    type: FILE_ADD,
    payload: {
        ...fileEntity,
        progress: 0,
        status: FILE_STATUS_UPLOADING,
        message: 'Uploading',
    }
});

export const fileUpdate = fileEntity => ({
    type: FILE_UPDATE,
    payload: fileEntity
});

export const fileProgress = (fileEntity, progress) => ({
    type: FILE_PROGRESS,
    payload: {
        uid: fileEntity.uid,
        progress: progress,
    }
});

export const fileSuccess = (fileEntity) => ({
    type: FILE_SUCCESS,
    payload: {
        progress: 100,
        status: FILE_STATUS_UPLOADED,
        message: 'Uploaded',
        ...fileEntity
    }
});

export const fileError = (fileEntity, message) => ({
    type: FILE_ERROR,
    payload: {
        uid: fileEntity.uid,
        status: FILE_STATUS_ERROR,
        message: typeof message === 'string' ? message : 'The file cannot be loaded',
    }
});

export const urlError = (fileEntity, message) => ({
    type: FILE_ERROR,
    payload: {
        uid: fileEntity.uid,
        status: URL_STATUS_ERROR,
        message: typeof message === 'string' ? message : 'We have no right to upload private media'
    }
});

export const fileDelete = (fileData) => ({
    type: FILE_DELETE,
    payload: fileData
});